import { render, staticRenderFns } from "./AboFeaturesList.vue?vue&type=template&id=26876498&scoped=true&"
import script from "./AboFeaturesList.vue?vue&type=script&lang=js&"
export * from "./AboFeaturesList.vue?vue&type=script&lang=js&"
import style0 from "./AboFeaturesList.vue?vue&type=style&index=0&id=26876498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26876498",
  null
  
)

export default component.exports